<template>
  <div class="animated fadeIn">
    <Loader :is-visible="loading" />

    <AccountingMarginRateFilters @apply="applyFilters" />

    <div class="card">
      <div class="card-header font-weight-bold">Suivi marge comptable</div>

      <div class="card-bloc">
        <div v-if="!stats" class="text-center text-muted">
          Sélectionnez des filtres, puis cliquez sur "Visualiser"
        </div>

        <div v-else class="row mx-1 mt-1">
          <div class="col-sm-4 mb-1" style="min-height: 110px">
            <div class="stat-card bg-success">
              <div>Taux de marge</div>
              <div class="font-weight-bold">{{ stats.marginRate }} %</div>
            </div>
          </div>

          <div class="col-sm-4 mb-1" style="min-height: 110px">
            <div class="stat-card bg-info">
              <div>CA en HT</div>
              <div class="font-weight-bold">{{ stats.turnover }} €</div>
            </div>
          </div>

          <div class="col-sm-4 mb-1" style="min-height: 110px">
            <div class="stat-card bg-info">
              <div>Cout coach en HT</div>
              <div class="font-weight-bold">{{ stats.totalCreditCoach }} €</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountingMarginRateFilters from "@/components/stats/AccountingMarginRateFilters.vue";
import Loader from "@/components/utils/Loader.vue";

export default {
  components: {
    AccountingMarginRateFilters,
    Loader,
  },

  data() {
    return {
      loading: false,
      stats: null,
      filters: {},
    };
  },

  methods: {
    applyFilters(filters) {
      this.filters = {
        ...this.filters,
        ...filters,
      };

      this.loadStats();
    },

    async loadStats() {
      try {
        this.loading = true;

        const { data } = await this.$api.get(
          "/exports/accounting-margin-rate",
          {
            params: this.filters,
          },
        );

        this.stats = data;
      } catch (e) {
        this.$errorToast("Impossible de charger cette statistique");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.stat-card {
  padding: 1rem;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
}
</style>
